<div id="input-image-content" class="image-container">
  <img id="image-src" class="image-content" [src]="question.src" />
</div>
